export default __webpack_public_path__ + "static/media/kroki.02712046.png";